import Link from "next/link";

export type ChatMessage = {
  id: string;
  role: "user" | "assistant";
  content: string;
};

export const QUICK_REPLIES = [
  { label: "AI 분석 이용법", message: "AI 음악 분석은 어떻게 이용하나요?" },
  { label: "프로 피드백 가격", message: "프로 피드백 가격과 옵션을 알려주세요." },
  { label: "포인트/회원가입", message: "회원가입 포인트와 심화 분석 비용이 궁금해요." },
];

export const WELCOME_MESSAGE =
  "안녕! 나는 ConnecTone AI 상담 토니야 🦊\n\nAI 분석, 프로 피드백, 포인트 등 궁금한 걸 편하게 물어봐!";

export function renderMessageContent(text: string) {
  const parts = text.split(/(\[[^\]]+\]\([^)]+\))/g);
  return parts.map((part, i) => {
    const linkMatch = part.match(/^\[([^\]]+)\]\(([^)]+)\)$/);
    if (linkMatch) {
      const [, label, href] = linkMatch;
      const isInternal = href.startsWith("/");
      if (isInternal) {
        return (
          <Link
            key={i}
            href={href}
            className="text-teal-600 underline underline-offset-2 hover:text-teal-700"
          >
            {label}
          </Link>
        );
      }
      return (
        <a
          key={i}
          href={href}
          target="_blank"
          rel="noopener noreferrer"
          className="text-teal-600 underline underline-offset-2 hover:text-teal-700"
        >
          {label}
        </a>
      );
    }
    return <span key={i}>{part}</span>;
  });
}
